import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { scGetAmc } from "../../lib/sifcontrolApi";

export default function SifControlAmcDetail() {
    const { id } = useParams();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [err, setErr] = useState(null);

    useEffect(() => {
        setLoading(true);
        scGetAmc(id)
            .then(setData)
            .catch((e) => setErr(e?.response?.data?.detail || "Not found"))
            .finally(() => setLoading(false));
    }, [id]);

    if (loading) return <div className="p-16 text-center text-sm text-oth-ink3">Loading…</div>;
    if (err) return <div className="p-16 text-center text-sm text-oth-ink3" data-testid="sc-amc-error">AMC not found.</div>;

    const a = data?.amc || {};
    const sifs = data?.sifs || [];

    return (
        <section className="py-14 md:py-20" data-testid="sc-amc-detail">
            <div className="mx-auto max-w-[1240px] px-4 md:px-6">
                <Link to="/sifcontrol/amcs" className="inline-flex items-center gap-1.5 text-xs font-body text-oth-ink3 hover:text-oth-ink">
                    <ArrowLeft size={13} /> All AMCs
                </Link>
                <h1 className="mt-4 font-display text-3xl md:text-4xl font-semibold tracking-tight text-oth-ink">{a.amc_name}</h1>
                <div className="mt-1 text-sm font-body text-oth-ink2">{sifs.length} SIFs</div>

                <div className="mt-10 rounded-3xl border border-oth-line bg-white overflow-hidden">
                    {sifs.length === 0 ? (
                        <div className="p-10 text-center text-sm font-body text-oth-ink3">No SIFs registered under this AMC yet.</div>
                    ) : (
                        <div className="divide-y divide-oth-line">
                            {sifs.map((s) => (
                                <Link
                                    to={`/sifcontrol/sif/${s.id}`}
                                    key={s.id}
                                    className="grid grid-cols-[1.4fr_1fr] items-center gap-4 px-5 py-4 hover:bg-oth-bg-2 transition-colors"
                                >
                                    <div>
                                        <div className="font-display text-sm md:text-base font-medium text-oth-ink">{s.sif_name}</div>
                                        <div className="text-[11px] font-body text-oth-ink3 mt-0.5">{s.sif_code}</div>
                                    </div>
                                    <div className="text-xs font-body text-oth-ink2">{s.strategy_category}</div>
                                </Link>
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
}
